import { Box, TextField, MenuItem, Button, Typography } from '@mui/material'
import { useEffect, useState } from 'react'
import useAmountOfCultivation from './hooks/useAmountOfCultivation';
import CalculateIcon from '@mui/icons-material/Calculate';
import { Col, Row } from 'antd';
import PrimarySearchAppBar from '../Layouts/PrimarySearchAppBar'

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '50vw',
    // height: '50vh',
    bgcolor: 'background.paper',
    borderRadius: '10px',
    p: 4,
    '& .MuiTextField-root': { m: 1 },
    '& button': { m: 1, mt: 2, width: '15ch' }

};




export default function AmountOfCultivationCalculator() {
    const [cropNo, setCropNo] = useState(0)
    const [cropList, setCropList] = useState([])
    const [landArea, setLandArea] = useState({
        rai: 0,
        ngan: 0,
        squareWa: 0
    })
    const [cropAmount, setCropAmount] = useState(0)
    const { fetchAmountOfCultivation } = useAmountOfCultivation()

    const cardBodyStyle = {
        border: ' grey',
        background: '#ffff',
        justifyContent: 'center',
        textAlign: 'center'
    }

    useEffect(() => {
        fetchAmountOfCultivation(setCropList)
    }, [])


    return (
        <Box className='otherSide' sx={{ backgroundColor: '#600537' }}>

            {/* <Box
                className='otherSide scrollbar-container'
                id="otherSide"
            >
            </Box> */}
            <Box sx={style}>
                <Row


                >
                    {/* <Box className='Title-map'> */}
                    <Typography variant="h5" color="#025464bf" > โปรแกรมคำนวณหลักเกณฑ์การใช้ประโยชน์ในการประกอบเกษตรกรรม</Typography>
                    {/* </Box> */}
                </Row>

                <Row
                    gutter={[8, 8]}
                // style={{   
                //     display:'flex',
                //     justifyContent :'space-evenly'
                // }}
                >


                    {/* </Box> */}
                    <Col span={12} >

                        <TextField
                            sx={{ width: '90%' }}
                            label='ชนิดพืช'
                            select
                            value={cropNo}
                            onChange={(event) => {
                                console.log(event.target.value)
                                setCropNo(event.target.value)
                                setCropAmount(0)
                            }}
                        >
                            {cropList.map((crop, index) => (
                                <MenuItem key={index} value={index}>{crop.crop_name}</MenuItem>
                            ))}
                        </TextField>
                    </Col>
                    <Col span={12} >
                        <TextField
                            sx={{ width: '90%' }}
                            type='number'
                            label='ไร่'
                            value={landArea.rai || ''}
                            onChange={(event) => {
                                setLandArea({ ...landArea, rai: event.target.value })
                            }}
                        />

                    </Col>

                    <Col span={12} >
                        <TextField
                            sx={{ width: '90%' }}
                            type='number'
                            label='งาน'
                            value={landArea.ngan || ''}
                            onChange={(event) => {
                                setLandArea({ ...landArea, ngan: event.target.value })
                            }}
                        />
                    </Col>
                    <Col span={12} >
                        <TextField
                            sx={{ width: '90%' }}
                            type='number'
                            label='ตารางวา'
                            value={landArea.squareWa || ''}
                            onChange={(event) => {
                                setLandArea({ ...landArea, squareWa: event.target.value })
                            }}
                        />
                    </Col>
                </Row>
                <Button
                    sx={{ marginLeft: '1ch' }}
                    variant='contained'
                    color='secondary'
                    startIcon={<CalculateIcon />}
                    onClick={() => {
                        const cal = ((landArea.rai * 400) + (landArea.ngan * 100) + parseFloat(landArea.squareWa)) * cropList[cropNo].crop_per_squarewa
                        // console.log(Math.ceil(cal))
                        setCropAmount(Math.ceil(cal))
                    }}
                >
                    คำนวณ
                </Button>
                <Typography variant="h3" gutterBottom>
                    {cropAmount > 0 ? `อัตราขั้นต่ำของการประกอบการเกษตร ${cropAmount} ต้น` : ''}
                </Typography>
                <Row


                >
                    {/* <Box className='Title-map'> */}

                    {/* </Box> */}
                </Row>
                <a href="https://www.dla.go.th/upload/document/type2/2568/4/33719_1_1744345845739.pdf" target="_blank" rel="noopener noreferrer">
                    ประกาศกระทรวงการคลังและกระทรวงมหาดไทย
                </a>

            </Box>
        </Box>
        // // <div >
        //     <Box
        //         className='otherSide scrollbar-container'
        //         id="otherSide"
        //     >
        //         <Box sx={style}>
        //             {/* <Box className='Title-map'> */}
        //             <Typography variant="h5" > โปรแกรมคำนวณหลักเกณฑ์การใช้ประโยชน์ในการประกอบเกษตรกรรม</Typography>
        //             <Row 
        //             gutter={[8, 8]}
        //             // style={{   
        //             //     display:'flex',
        //             //     justifyContent :'space-evenly'
        //             // }}
        //             >


        //                 {/* </Box> */}
        //                 <Col span={12} >

        //                     <TextField
        //                         sx={{ width: '20ch' }}
        //                         label='ชนิดพืช'
        //                         select
        //                         value={cropNo}
        //                         onChange={(event) => {
        //                             console.log(event.target.value)
        //                             setCropNo(event.target.value)
        //                             setCropAmount(0)
        //                         }}
        //                     >
        //                         {cropList.map((crop, index) => (
        //                             <MenuItem key={index} value={index}>{crop.crop_name}</MenuItem>
        //                         ))}
        //                     </TextField>
        //                 </Col>
        //                 <Col span={12} >
        //                     <TextField
        //                         sx={{ width: '20ch' }}
        //                         type='number'
        //                         label='ไร่'
        //                         value={landArea.rai || ''}
        //                         onChange={(event) => {
        //                             setLandArea({ ...landArea, rai: event.target.value })
        //                         }}
        //                     />

        //                 </Col>

        //                 <Col span={12} >
        //                     <TextField
        //                         sx={{ width: '20ch' }}
        //                         type='number'
        //                         label='งาน'
        //                         value={landArea.ngan || ''}
        //                         onChange={(event) => {
        //                             setLandArea({ ...landArea, ngan: event.target.value })
        //                         }}
        //                     />
        //                 </Col>
        //                 <Col>
        //                     <TextField
        //                         sx={{ width: '20ch' }}
        //                         type='number'
        //                         label='ตารางวา'
        //                         value={landArea.squareWa || ''}
        //                         onChange={(event) => {
        //                             setLandArea({ ...landArea, squareWa: event.target.value })
        //                         }}
        //                     />
        //                 </Col>
        //             </Row>
        //             <Button
        //                 sx={{ marginLeft: '1ch' }}
        //                 variant='contained'
        //                 color='secondary'
        //                 startIcon={<CalculateIcon />}
        //                 onClick={() => {
        //                     const cal = ((landArea.rai * 400) + (landArea.ngan * 100) + parseFloat(landArea.squareWa)) * cropList[cropNo].crop_per_squarewa
        //                     // console.log(Math.ceil(cal))
        //                     setCropAmount(Math.ceil(cal))
        //                 }}
        //             >
        //                 คำนวณ
        //             </Button>
        //             <Typography variant="h3" gutterBottom>
        //                 {cropAmount > 0 ? `อัตราขั้นต่ำของการประกอบการเกษตร ${cropAmount} ต้น` : ''}
        //             </Typography>
        //         </Box>
        //     </Box>
        // // </div>
    )
}
